import { useState } from 'react';
import { listOrEmpty } from '../utils/customReportUtils';

/** The editable fields of a report version and the payload the API saves from them. */
export const useReportForm = ({ scope, scopeId, isSynthesis, defaultSelectedIds, missions = false }) => {
  const [reportTitle, setReportTitle] = useState('');
  const [promptText, setPromptText] = useState('');
  const [selectedIds, setSelectedIds] = useState(defaultSelectedIds);
  const [reportKind, setReportKind] = useState('');
  const [dayNumber, setDayNumber] = useState(1);
  const [country, setCountry] = useState('');
  const [takeOfficial, setTakeOfficial] = useState(false);
  const currentSessionIds = scope === 'session' && scopeId ? [scopeId] : selectedIds;

  const fillFrom = (page, fallbackIds) => {
    setReportTitle(page.title || '');
    setPromptText(page.prompt || '');
    const ids = listOrEmpty(page.session_ids);
    setSelectedIds(ids.length > 0 ? ids : fallbackIds);
    setReportKind(page.report_kind || '');
    setDayNumber(page.day_number || 1);
    setCountry(page.country || '');
    setTakeOfficial(Boolean(page.report_kind) && page.is_official !== false);
  };

  /** Empties the fields; the session selection stays for the next version. */
  const clear = () => {
    setReportTitle('');
    setPromptText('');
    setReportKind('');
    setDayNumber(1);
    setCountry('');
    setTakeOfficial(false);
  };

  const changeFlags = (change) => {
    if ('report_kind' in change) setReportKind(change.report_kind);
    if ('day_number' in change) setDayNumber(change.day_number);
    if ('take_official' in change) setTakeOfficial(change.take_official);
    if ('country' in change) setCountry(change.country);
  };

  /** `overrides` holds flags changed in this event, before their state update lands. */
  const payload = (overrides = {}) => {
    const kind = overrides.report_kind !== undefined ? overrides.report_kind : reportKind;
    const day = overrides.day_number !== undefined ? overrides.day_number : dayNumber;
    const official = overrides.take_official !== undefined ? overrides.take_official : takeOfficial;
    const countryName = overrides.country !== undefined ? overrides.country : country;
    return {
      title: reportTitle.trim() || 'Untitled report',
      prompt: promptText,
      session_ids: currentSessionIds,
      ...(scope === 'event' && !isSynthesis ? {
        report_kind: kind || '',
        day_number: kind === 'daily' ? Number(day) || 1 : undefined,
        take_official: Boolean(kind) && official,
      } : {}),
      ...(missions ? { country: countryName.trim() } : {}),
    };
  };

  return {
    reportTitle,
    setReportTitle,
    promptText,
    setPromptText,
    selectedIds,
    setSelectedIds,
    reportKind,
    dayNumber,
    country,
    takeOfficial,
    currentSessionIds,
    fillFrom,
    clear,
    changeFlags,
    payload,
  };
};
